/* global Modernizr */

import { Controller } from 'stimulus';

const BREAKPOINT = 991;
const isMobile = () => Modernizr.mq(`(max-width: ${BREAKPOINT}px)`);

class Collapse extends Controller {
  toggle() {
    if (isMobile()) {
      this.togglerTarget.classList.toggle('is-open');
      this.element.style.height = '100%';
    }
  }
}

Collapse.targets = [
  'toggler',
];

export default Collapse;
